import { Box, Checkbox } from "@procore/core-react";

import { type GroupState } from "utils/treeHelpers";

interface TreeNodeCheckboxProps {
    selected: GroupState;
    onSelection: () => void;
}

export function TreeNodeCheckbox({ selected, onSelection }: TreeNodeCheckboxProps) {
    const stopPropagation: React.MouseEventHandler = (e) => {
        e.stopPropagation();
    };

    return (
        <Box onClick={stopPropagation}>
            <Checkbox checked={selected === "all"} indeterminate={selected === "some"} onChange={onSelection} />
        </Box>
    );
}
